import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { SubscriptionExpirySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportSubscriptionExpiry, sortSubscriptionExpiry } from '../../constants';
import { getSubscriptionExpiry, getAllSubscriptionExpiry } from '../../actions';
import { makeGetListSubscriptionExpiry, makeGetListAllSubscriptionExpiry } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class SubscriptionExpiry extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listSubscriptionExpiry: [],
    emails: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listSubscriptionExpiry: props.listSubscriptionExpiry,
      totalCount: getPageTotalCount({ ...state, items: props.listSubscriptionExpiry }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetSubscriptionReport },
    } = this.props;
    if (modeGetSubscriptionReport) {
      this.doGetOutputTemplateByType();
      this.doGetListSubscriptionExpiry();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListSubscriptionExpiry();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListSubscriptionExpiry());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListSubscriptionExpiry());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListSubscriptionExpiry();
    });
  };

  doGetListSubscriptionExpiry = () => {
    const { filter, page, size, sorted } = this.state;
    const { getSubscriptionExpiry } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortSubscriptionExpiry[sorted.sortCol]
          ? sortSubscriptionExpiry[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getSubscriptionExpiry(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistSubscriptionExpiry = cb => {
    const { filter, sorted } = this.state;
    const { getAllSubscriptionExpiry } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortSubscriptionExpiry[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllSubscriptionExpiry(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistSubscriptionExpiry(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllSubscriptionExpiry, t } = this.props;
        convertJson2Pdf({
          data: listAllSubscriptionExpiry,
          t,
          title: t('reportPage:sidebar.subscriptionExpiry').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.subscriptionExpiry')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistSubscriptionExpiry(() => {
      const { listAllSubscriptionExpiry, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_SUBSCRIPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.subscriptionExpiry')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.subscriptionExpiry')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllSubscriptionExpiry,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              accountType: 'accountType',
              initialTermUnit: 'initialTermUnit',
              renewalTermUnit: 'initialTermUnit',
              status: 'subscriptionStatus',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllSubscriptionExpiry,
          t,
          title: t('reportPage:sidebar.subscriptionExpiry').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.subscriptionExpiry')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.subscriptionExpiry')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('SUBSCRIPTION_EXPIRY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportSubscriptionExpiry,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listSubscriptionExpiry,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllSubscriptionExpiry,
      t,
      permissions: { modeGetSubscriptionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetSubscriptionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.subscriptionExpiry') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.subscriptionExpiry')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <SubscriptionExpirySearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.subscriptionExpiry').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllSubscriptionExpiry,
                          t,
                          title: t('reportPage:sidebar.subscriptionExpiry').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.subscriptionExpiry')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listSubscriptionExpiry}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listSubscriptionExpiry && listSubscriptionExpiry.length ? listSubscriptionExpiry : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

SubscriptionExpiry.propTypes = {
  getSubscriptionExpiry: PropTypes.func,
  getAllSubscriptionExpiry: PropTypes.func,
  listAllSubscriptionExpiry: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

SubscriptionExpiry.defaultProps = {
  getSubscriptionExpiry: () => {},
  getAllSubscriptionExpiry: () => {},
  listAllSubscriptionExpiry: [],
};

const mapStateToProps = createStructuredSelector({
  listSubscriptionExpiry: makeGetListSubscriptionExpiry() || [],
  listAllSubscriptionExpiry: makeGetListAllSubscriptionExpiry() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getSubscriptionExpiry,
    getAllSubscriptionExpiry,
    parseToMutationRequestPostMethod,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(SubscriptionExpiry)
);
